import { Injectable } from '@angular/core';

import { SearchMethod } from '@patient-ui/patient-web/store';

const FIND_A_LAB_TRACKING_CONTEXT_KEY = 'findALabTrackingContext';

/** Search context persisted at slot hold for the Appointment Scheduled event. */
export interface FindALabTrackingContext {
  preferred_date: string;
  search_method?: SearchMethod;
  zip?: string;
}

@Injectable({ providedIn: 'root' })
export class FindALabTrackingContextService {
  save(context: FindALabTrackingContext): void {
    sessionStorage.setItem(
      FIND_A_LAB_TRACKING_CONTEXT_KEY,
      JSON.stringify(context)
    );
  }

  read(): FindALabTrackingContext | null {
    const item = sessionStorage.getItem(FIND_A_LAB_TRACKING_CONTEXT_KEY);
    if (!item) {
      return null;
    }

    try {
      return JSON.parse(item) as FindALabTrackingContext;
    } catch {
      return null;
    }
  }

  clear(): void {
    sessionStorage.removeItem(FIND_A_LAB_TRACKING_CONTEXT_KEY);
  }
}
